import type { GA4AnalyticsEvent } from '@/domain/shared/types';
import type { AnalyticsClient } from '../../domain/types';

const createGA4AnalyticsClient = (): AnalyticsClient => {
  function sendEvent<T = GA4AnalyticsEvent>(event: T) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }

  return {
    sendEvent,
  };
};

export default createGA4AnalyticsClient();
